import getCurrentPlanSelect from '../../selectors/get-current'
import getStartedPlanSelect from '../../selectors/get-started'
import updateReduxAction from '../../../redux/actions/update'
import { getPathReduxUtil } from '../../../redux/utils/get-path'
import { logUtil } from 'packages/src'

function updatePlanAction (action) {
  return (dispatch, getState) => {
    const { payload } = action
    let {
      key,
      value,
      keys,
      values,
      plan
      // options = {}
    } = payload
    // const shouldSave = options[REDUX_OPTION.SHOULD_SAVE] ?? true
    // Update the plan
    plan = plan ||
      getCurrentPlanSelect(getState()) ||
      getStartedPlanSelect(getState())
    if (!plan) {
      logUtil('').info('plan was not found for action: ', action)
      return
    }
    const updates = {}
    if (keys) {
      keys.forEach((key, index) => {
        updates[key] = values[index]
      })
    } else {
      updates[key] = value
    }
    dispatch(updateReduxAction({
      type: action.type,
      payload: {
        path: getPathReduxUtil(plan),
        updates
      }
    }))
    //
    // if (!isNewReduxUtil(plan) && shouldSave) {
    //   dispatch(
    //     savePlanAction(getIdReduxUtil(plan))
    //   )
    // }
  }
}

export default updatePlanAction
